import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import '../../../assets/css/authenticationStyles.css';
import notap_logo from '../../../assets/images/notap_logo.png';
import {
    clearAll,
    setErrorMessage,
    onUserLogin,
    setLoading
} from "../../../config/redux/slice/authSlice";
import { postRequest, getRequest } from '../../../helpers/request';
import { appApi } from '../../../utils/endpoints/appApi';
import { appUrls } from '../../../utils/urls/appUrls';
import { AuthAlert, Spinner } from '../../components';

export default function ProfileCreation() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const {register, handleSubmit, formState: {errors}} = useForm({mode: 'onTouched'})
  const {
        token,
        loading,
        errorMsg,
        userData: {isProfileComplete, user_role}
    } = useSelector((state) => state.authData)

    const [banks, setBanks] = useState([])

    useEffect(()=>{
      dispatch(clearAll({}))
      if(isProfileComplete){
        navigate(appUrls.dashboard)
      }
      getBanks()
    }, [])

    const getBanks = async () =>{
      const res = await getRequest(
        token,
        `${appApi.banks}`,
        {},
        dispatch,
        "",
        "",
        ""
      )
      if(res !== undefined && res.status < 400){
          setBanks(res.data.data || res.data || []);
      }
    }

    const onSubmit = async (data) => {
        dispatch(clearAll({}))
        const res = await postRequest(
            token,
            `${appApi.profile_creation}`,
            data,
            dispatch,
            setLoading,
            onUserLogin,
            setErrorMessage
        )
        if(res !== undefined && res.status < 400){
          navigate(appUrls.profileCreationSuccess)
        }
    }

    const closeAlert = () => {
        dispatch(setErrorMessage({message: null}))
    }

  return (
    <div className='d-flex justify-content-center align-items-baseline profile-creation'>
      <div style={{marginTop: '2rem'}}  className='card card-default pt-5 px-5 pb-0'>
        <div className='formContainer'>
            <div style={{columnGap: '1rem'}} className='d-flex align-items-center justify-content-center'>
              <img src={notap_logo} alt='logo' className='logotypeImage' />
              <h2 className='font-weight-bold'>
                NOTAP Portal
              </h2>              
            </div>
            <div style={{columnGap: '0.8rem'}} className='greeting d-flex justify-content-center align-items-center'>
              <p style={{fontSize: '1.3rem'}} className={`text-capitalize`}>
                Enter Your Details to create profile
              </p>
            </div>
            <form className='mainForm' onSubmit={handleSubmit(onSubmit)}>
              <div className="row w-100 m-0">
                {errorMsg && <AuthAlert onClick={closeAlert} alertStyles={{width: '95%', margin: '0 auto'}} status='error'>
                    {errorMsg}
                </AuthAlert>}
                {user_role == 'BANK_USER' &&
                <div className="form-group col-md-12 mb-4">
                  <label htmlFor='bank_id'>Bank Name</label>
                  <select 
                    className="form-control rounded-0" 
                    id="bank_id"
                    {...register("bank_id", {
                        required: {
                        value: true,
                        message: '*this field is required'
                        }
                    })
                    } 
                  >
                    <option value={''}>Select Bank</option>
                    {banks.map((bank)=>{
                      return <option key={bank.ID} value={bank.ID}>{bank.BANK_NAME}</option>
                    })}
                  </select>
                  {
                    errors?.bank_id?.message &&
                    <div className="text-danger small mt-1">
                        {errors?.bank_id?.message}
                    </div>
                    }
                </div>
                }
                {/* <div className="form-group col-md-12 mb-4">
                    <label htmlFor='bank_name'>Bank Name</label>
                    <input 
                    type="text" 
                    className="form-control input-lg" 
                    id="bank_name"
                    {...register("bank_name", {
                        required: {
                        value: true,
                        message: '*this field is required'
                        }
                    })
                    } 
                    />
                    {
                    errors?.first?.message &&
                    <div className="text-danger small mt-1">
                        {errors?.first?.message}
                    </div>
                    }
                </div>  */}
                {user_role == 'BANK_USER' &&
                <div className="form-group col-md-12 mb-4">
                    <label htmlFor='user_bank_role'>Role</label>
                    <input 
                    type="text" 
                    className="form-control input-lg" 
                    id="user_bank_role"
                    {...register("user_bank_role", {
                        required: {
                        value: true,
                        message: '*this field is required'
                        }
                    })
                    } 
                    />
                    {
                    errors?.user_bank_role?.message &&
                    <div className="text-danger small mt-1">
                        {errors?.user_bank_role?.message}
                    </div>
                    }
                </div>  
                }
                <div className="form-group col-md-12 mb-4">
                    <label htmlFor='contact_email'>Contact Email</label>
                    <input 
                    type="email" 
                    className="form-control input-lg" 
                    id="contact_email" 
                    aria-describedby="contact_emailHelp"
                    {...register("contact_email", {
                        required: {
                        value: true,
                        message: '*this field is required'
                        },
                        pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: '*invalid contact email pattern'
                        }
                    })
                    }
                    />
                    {
                    errors?.contact_email?.message &&
                    <div className="text-danger small mt-1">
                        {errors?.contact_email?.message}
                    </div>
                    }
                </div>
                <div className="form-group col-md-12 mb-4">
                    <label htmlFor='phone_number'>Phone Number</label>
                    <input 
                    type="text" 
                    className="form-control input-lg" 
                    id="phone_number"
                    {...register("phone_number", {
                        required: {
                        value: true,
                        message: '*this field is required'
                        },
                        pattern: {
                        value: /^0\d{10}$/i,
                        message: '*invalid phone number pattern'
                        }
                    })
                    } 
                    />
                    {
                    errors?.phone_number?.message &&
                    <div className="text-danger small mt-1">
                        {errors?.phone_number?.message}
                    </div>
                    }
                </div>              
                <div className="col-md-12">

                    <div>
                    {loading ? 
                        <Spinner/> :
                        <button type="submit" className="btn btn-primary mb-4">Submit</button>
                    }
                    </div>
                </div>
              </div>
            </form>
        </div>        
      </div>        
    </div>
  )
}
